import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  TrainingRequirementSkeleton,
  TrainingRequirementAudit,
  WarningRuleAudit
} from '../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-training-event-audit-list',
  templateUrl: './training-event-audit-list.component.html',
  styleUrls: ['./training-event-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingEventAuditListComponent implements OnInit {
  @Input() trainingRequirementSkeletons: TrainingRequirementSkeleton[];
  @Input() loading: boolean;
  @Input() audits: TrainingRequirementAudit[];
  @Input() warningRuleAuditLoading: boolean;
  @Input() warningRuleAudits: WarningRuleAudit[];

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();
  @Output() openedWarningRule = new EventEmitter<number>();
  @Output() nextWarningRulePage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(trainingRequirementId: number) {
    this.opened.emit(trainingRequirementId);
  }

  onNextPage(trainingRequirementId: number) {
    this.nextPage.emit(trainingRequirementId);
  }

  onOpenedWarningRule(warningRuleId: number) {
    this.openedWarningRule.emit(warningRuleId);
  }

  onNextWarningRulePage(warningRuleId: number) {
    this.nextWarningRulePage.emit(warningRuleId);
  }
}
